<template>
    <div class="font-poppins">
        <div class="flex md:flex-col">
            <AdminDashboardNav/>

            <div class="w-screen p-2">
                <div class="flex justify-between md:flex-col-reverse pt-5">
                    <div>
                        <GetDate/>
                        <div class="flex">
                            <p class="text-blue-700 font-bold text-2xl">MANAGE ADMINS</p>
                        </div>
                    </div>
                    <div>
                        <Notification/>
                    </div>
                </div>
                
                    <div class="p-4">
                        <div class="flex mt-4">
                            <div @click="goBack" class="flex">
                                <i class="fa fa-arrow-left"></i>
                                <p class="ml-3">Go Back</p>
                            </div>
                            <p class="ml-6 text-blue-700">Add Admin</p>
                        </div>
                    </div>

                    <div class="p-4">
                        <div >
                            <div v-if="isAdminAdded" class="border border-green-500 text-green-400 bg-green-100 p-2 mt-4">
                            <p>Admin Added successfully</p>
                        </div>
                        <div>
                                <form @submit.prevent="addAdmin" class="flex md:flex-col-reverse" enctype="multipart/form-data">
                                    <div class="w-1/2 md:w-full md:mt-3">
                                        <div>
                                            <select class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" name="account-type" id="account-type" @change="onAccountType($event)">
                                                <option selected value="Account Type">Account Type</option>
                                                <option value="subAdmin">Sub Admin</option>
                                            </select>
                                            <p v-if="accountTypeValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                        </div>
                                        
                                        <div class="mt-2">
                                            <input class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" type="text" name="first-name" id="first-name" placeholder="First Name" v-model="firstName">
                                            <p v-if="firstNameValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                        </div>
                                        <div class="mt-2">
                                            <input class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" type="text" name="last-name" id="last-name" placeholder="Last Name" v-model="lastName">
                                            <p v-if="lastNameValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                        </div>
                                        <div class="mt-2">
                                            <input class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" type="email" name="email" id="email" placeholder="Email" v-model="email">
                                            <p v-if="emailValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                        </div>
                                        <div class="mt-2">
                                            <input class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" :type="[showPassword ? 'text' : 'password']" name="password" id="password" placeholder="Password" v-model="password">
                                            <span @click="showPassword = !showPassword">
                                                <i class="fa  -ml-8 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                            </span>
                                            <p v-if="passwordValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                            <p v-show="incorrectPassword" class=" text-xs text-red-500">Password must include number and be greater than 8..</p>
                                        </div>
                                        
                                        <div class="mt-2">
                                            <input class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" type="number" name="phone" id="phone" placeholder="Phone Number" v-model="phone">
                                            <p v-if="phoneValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                        </div>
                                        <div class="mt-2">
                                            <input style="display:none" type="file" name="image" id="image" @change="onImage" ref="imageUpload">
                                            <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.imageUpload.click()">--upload file-- {{this.imageName}} </p>
                                            <p v-if="imageValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                        </div>
                                        
                                        <div class="mt-8 flex">
                                            <button class="text-white p-3 rounded-lg" style="background-color:#0048AE">Submit</button>
                                            <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                        </div>
                                    </div>
                                    
                                    <div class="ml-8 md:ml-0">
                                        <p>Select Privileges</p>
                                        <div  class="mt-3">
                                            <div v-for="privilege in privileges" :key="privilege" class="flex mt-2">
                                                <input class="mt-1" type="checkbox" name="privilege" v-model="selectedPrivileges"
                                                 :value="privilege"
                                                >
                                                <label class="ml-2" for="privilege">{{privilege}}</label>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </form>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <SuccessfulModal
        v-show="successModal"
        @click="closeSuccessModal"
        :message="message"
        />
        <ErrorModal
        v-show="errorModal"
        @click="closeErrorModal"
        :message="message"
        :incorrectPassword="incorrectPassword"
        />
    </div>
</template>

<script>
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import axios from 'axios';
import SuccessfulModal from './SuccessfulModal.vue';
import ErrorModal from '../ErrorModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        SuccessfulModal,
        ErrorModal
    },
    data() {
        return {
            image: null,
            imageName: null,
            isLoading: false,
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            phone: "",
            accountType: "",
            firstNameValidity: "",
            lastNameValidity: "",
            emailValidity: "",
            passwordValidity: "",
            phoneValidity: "",
            accountTypeValidity: "",
            imageValidity: "",
            userId: localStorage.getItem('userId'),
            privileges: [
                "Users",
                "Orders",
                "Riders",
                "DSOs",
                "Manage Admin",
                "Transactions",
                "Configuration",
                "Sales Report"
            ],
            selectedPrivileges: [],
            allSelected: false,
            isAdminAdded: false,
            token: localStorage.getItem("token"),
            errorModal: false,
            successModal: false,
            message: "",
            showPassword:false,
            incorrectPassword: ""
        }
    },

    methods: {
        closeSuccessModal() {
            this.successModal = false;
            this._getCurrentPrice()
        },
        closeErrorModal() {
            this.errorModal = false
        },
        onImage(event) {
            this.image = event.target.files[0];
            this.imageName = event.target.files[0].name;
        },
        onAccountType(event) {
            this.accountType = event.target.value;
        },
        goBack() {
            this.$router.go(-1)
        },

        selectAll() {
            if (this.allSelected) {
                const selected = this.privileges.map((u) => u);
                this.selectedPrivileges = selected;
                console.log(this.selectedPrivileges)
            } else {
                this.selectedPrivileges = [];
                console.log(this.selectedPrivileges)
            }
        },

        addAdmin() {
            if(!this.firstName) {
                this.firstNameValidity = 'invalid';
                setTimeout(() => {
                this.firstNameValidity = '';
                }, 3000);
            } else if(!this.lastName) {
                this.lastNameValidity = 'invalid';
                setTimeout(() => {
                this.lastNameValidity = '';
                }, 3000);
            } else if(!this.password || this.password.length < 8 || this.password.search(/[0-9]/) < 0) {
                this.incorrectPassword = "Password must include numbers and be greater than 8"
                setTimeout(() => {
                this.incorrectPassword = '';
                }, 3000);

            } else if(!this.email) {
                this.emailValidity = 'invalid';
                setTimeout(() => {
                this.emailValidity = '';
                }, 3000);
            } else if(!this.phone) {
                this.phoneValidity = 'invalid';
                setTimeout(() => {
                this.phoneValidity = '';
                }, 3000);
            } else if (!this.image) {
                this.imageValidity = 'invalid';
                setTimeout(() => {
                this.imageValidity = '';
                }, 3000);
            } else if(!this.accountType) {
                this.accountTypeValidity = 'invalid';
                setTimeout(() => {
                this.accountTypeValidity = '';
                }, 3000);
            } else if (!this.selectedPrivileges){
                this.selectedPrivileges = 'invalid'
                setTimeout(() => {
                this.selectedPrivileges = '';
                }, 3000);
            }
            else {
                this.isLoading = true;
                 let data = new FormData();
                data.append('firstName', this.firstName);
                data.append('lastName', this.lastName);
                data.append('email', this.email); 
                data.append('phone', this.phone); 
                data.append('image', this.image); 
                data.append('password', this.password); 
                data.append('accountType', this.accountType); 
                data.append('adminId', this.userId); 
                this.selectedPrivileges.forEach((privilege) => data.append("privileges[]", privilege))
                // data.append('privileges[]', this.selectedPrivileges);
                axios({
                method: 'POST',
                url: `${url}/v1/web/users/admin/add`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    Authorization: `Bearer ${this.token}`
                },
                data:data
            })
            .then((res) => { 
                res.json
                this.isLoading = false;
                this.successModal = true;
                this.message = "Admin Successfully added"
            })
            .catch((err) => {
                this.errorModal = true;
                this.message = err.response.data.message
                this.isLoading = false;
               
            })
            }
        }
    }
}
</script>